import axios, { AxiosRequestConfig } from 'axios';
import { default as config } from '../constants/constants';

/**
 * Checks if an email exists.
 * @param email The email address to check.
 * @returns If the email exists, returns an object containing the response data.
 * If the email doesn't exist, returns an empty string.
 * @throws If an error occurs during the API call, rejects with the error object.
 */
export const emailExists = async (email: string) => {
  try {
    const response = await axios.get(
      `${config.serverURL}/user/checkEmail?email=${email}`
    );
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const updateASUUserAndSubscribeInCategory = async (
  token: string,
  data: { code: string; name: string; studentId: string }
) => {
  const options: AxiosRequestConfig = {
    method: 'PUT',
    headers: { 'X-Firebase-Auth': token },
    url: `${config.serverURL}/auth/user/asu`,
    data
  };

  return axios(options);
};
